<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialog" persistent max-width="350">
          <v-card>
            <v-card-title class="headline">Delete selected profile?</v-card-title>
            <v-card-text class="text-xs-left">You are going to delete this selected profile.
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialog = false">cancel</v-btn>
              <v-btn color="accent" flat @click="deleteApprovalProfileById" :loading="isLoading" :disable="isLoading">delete
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-layout row justify-center>
        <v-dialog v-model="dialogForm" persistent max-width="400">
          <v-card>
            <v-card-title class="headline">New Approval Profile</v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12>
                    <v-text-field v-model="profile.description" label="Profile description"
                                  :error-messages="errors.collect('description')" v-validate="'required'"
                                  data-vv-name="description" required></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select v-bind:items="getAllCompanies" v-model="profile.company_code" label="Company code"
                              item-value="company_code" :error-messages="errors.collect('company code')"
                              v-validate="'required'" data-vv-name="company code" required>
                      <template slot="selection" slot-scope="data">
                        {{ data.item.company_code }} - {{ data.item.description }}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ data.item.company_code }} - {{ data.item.description }}
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select v-bind:items="types" v-model="profile.type" label="Document type"
                              item-value="type" :error-messages="errors.collect('document_type')"
                              v-validate="'required'" data-vv-name="document_type" required>
                      <template slot="selection" slot-scope="data">
                        {{ data.item.type }} - {{ data.item.description }}
                      </template>
                      <template slot="item" slot-scope="data">
                        {{ data.item.type }} - {{ data.item.description }}
                      </template>
                    </v-select>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="accent" flat @click="dialogForm = false">cancel</v-btn>
              <v-btn color="accent" flat @click="addProfile" :loading="isLoading" :disable="isLoading">
                save
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-flex>

    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Details</span>
          <v-spacer></v-spacer>
        </v-card-title>
        <v-divider></v-divider>
        <v-card>
          <v-card-title>
            <v-btn dark color="accent" @click="dialogForm = true">new approval limit</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          </v-card-title>
          <v-data-table
            v-if="!isLoading"
            loading="true"
            v-bind:headers="headers"
            v-bind:items="items"
            v-bind:search="search"
            v-model="selected"
            item-key="id"
            class="elevation-1">
            <template slot="headerCell" slot-scope="props">
            <span>
              {{ props.header.text }}
            </span>
            </template>
            <template slot="items" slot-scope="props">
              <td class="text-xs-left">
                <v-tooltip bottom>
                  <v-btn flat icon @click="editPlantById(props.item.id)" color="accent lighten-1" slot="activator">
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <span>Change</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <v-btn flat icon @click="toggleDialog(props.item.id)" color="error lighten-1" slot="activator">
                    <v-icon>delete</v-icon>
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
              </td>
              <td class="text-xs-left">{{ props.item.id}}</td>
              <td class="text-xs-left">{{ props.item.description}}</td>
              <td class="text-xs-left">{{ props.item.company_code}}</td>
              <td class="text-xs-left">{{ props.item.type}}</td>
            </template>
          </v-data-table>
          <v-progress-circular indeterminate color="primary" v-if="isLoading"></v-progress-circular>

    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
        </v-card>
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'limit-detail',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      search: '',
      selected: [],
      selectedId: '',
      dialog: false,
      dialogForm: false,
      profile: {
        description: '',
        company_code: ''
      },
      types: [
        { type: 'PR', description: 'Purchase requisition' },
        { type: 'PO', description: 'Purchase order' }
      ],
      headers: [
        {
          text: 'Actions',
          align: 'left',
          value: 'actions',
          sortable: false
        },
        {
          text: 'ID',
          align: 'left',
          value: 'id'
        },
        {
          text: 'Description',
          align: 'left',
          value: 'description'
        },
        {
          text: 'Company Code',
          align: 'left',
          value: 'company_code'
        },
        {
          text: 'Document Type',
          align: 'left',
          value: 'type'
        }
      ],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: ''
    }
  },
  methods: {
    ...mapActions([
      'fetchAllApprovalProfiles',
      'addApprovalProfile',
      'deleteApprovalProfile'
    ]),

    addProfile: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.addApprovalProfile(this.profile).then(() => {
            this.dialogForm = false
            let response = this.getResponse
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Added successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    },

    editPlantById: function (id) {
      this.$router.push({ name: 'changeLimit', params: { id: id } })
    },

    toggleDialog: function (id) {
      this.selectedId = id
      this.dialog = true
    },

    deleteApprovalProfileById: function () {
      this.deleteApprovalProfile(this.selectedId).then(() => {
        this.dialog = false
        let response = this.getResponse
        this.snackbar = true
        this.text =
          response.status === 200
            ? 'Deleted successfully.'
            : response.data.message
        this.color = response.status === 200 ? 'success' : 'error'
      })
    },

    loadApprovalProfiles: function () {
      this.fetchAllApprovalProfiles()
        .then(() => {
          //  do nothing
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  mounted: function () {
    this.loadApprovalProfiles()
    this.fetchAllCompanies()
  },
  computed: {
    ...mapGetters({
      items: 'getApprovalProfiles',
      isLoading: 'getLoading',
      getResponse: 'getResponse',
      getAllCompanies: 'getAllCompanies'
    })
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>

<style lang="stylus" scoped>
div {
  text-align: center;
}

.progress-circular {
  margin: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/approval-limit/LimitDetail.vue